import { HttpContextToken } from '@angular/common/http';

/** Skip attaching bearer token (login / refresh). */
export const SKIP_AUTH_TOKEN = new HttpContextToken<boolean>(() => false);

/** Marks a retried request so the interceptor does not loop on 401. */
export const AUTH_RETRY = new HttpContextToken<boolean>(() => false);
